/* Chydee Premium — scroll-reveal + stagger animations */
(function () {
  'use strict';

  if (typeof IntersectionObserver === 'undefined') return;

  /* ── Observer factory ── */
  function makeObs(callback, options) {
    return new IntersectionObserver(callback, Object.assign(
      { threshold: 0.07, rootMargin: '0px 0px -48px 0px' },
      options || {}
    ));
  }

  /* ── Generic reveal observer ── */
  var revealObs = makeObs(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObs.unobserve(entry.target);
      }
    });
  });

  function revealEl(el, delayS) {
    if (!el) return;
    el.classList.add('chyd-reveal');
    if (delayS) el.style.transitionDelay = delayS + 's';
    revealObs.observe(el);
  }

  /* ── How-it-works: stagger steps when grid enters view ── */
  var gridObs = makeObs(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.querySelectorAll('.hiw__step').forEach(function (step, i) {
        step.classList.add('chyd-reveal');
        setTimeout(function () {
          step.classList.add('is-visible');
        }, i * 85 + 40);
      });
      gridObs.unobserve(entry.target);
    });
  }, { threshold: 0.04 });

  /* ── Testimonials: stagger cards when marquee-wrap enters view ── */
  var marqueeObs = makeObs(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      revealEl(entry.target.closest('.ctm') && entry.target.closest('.ctm').querySelector('.ctm__header'));
      marqueeObs.unobserve(entry.target);
    });
  }, { threshold: 0.06 });

  function init() {

    /* ── Trust bar inner ── */
    document.querySelectorAll('.ctb__inner').forEach(function (el) {
      revealEl(el, 0);
    });

    /* ── Feature bar: stagger each item ── */
    document.querySelectorAll('.cfs__item').forEach(function (el, i) {
      revealEl(el, i * 0.1);
    });

    /* ── How-it-works header + stagger grid ── */
    document.querySelectorAll('.hiw__header').forEach(function (el) {
      revealEl(el, 0);
    });
    document.querySelectorAll('.hiw__grid').forEach(function (el) {
      gridObs.observe(el);
    });

    /* ── Testimonials header ── */
    document.querySelectorAll('.ctm__header').forEach(function (el) {
      revealEl(el, 0);
    });
    document.querySelectorAll('.ctm__marquee-wrap').forEach(function (el) {
      marqueeObs.observe(el);
    });

    /* ── Photo gallery section ── */
    document.querySelectorAll('.media-guide__header').forEach(function (el) {
      revealEl(el, 0);
    });
    document.querySelectorAll('.media-guide__grid').forEach(function (el) {
      revealEl(el, 0.12);
    });

    /* ── Final CTA container ── */
    document.querySelectorAll('.final-cta-container').forEach(function (el) {
      revealEl(el, 0);
    });

    /* ── Product hero: gallery fades in first, info side follows ── */
    document.querySelectorAll('.cph__gallery').forEach(function (el) {
      revealEl(el, 0);
    });
    document.querySelectorAll('.cph__info').forEach(function (el) {
      revealEl(el, 0.14);
    });

    /* ── Spec / About / Brand sections — reveal headers ── */
    [
      '.chydee-specs',
      '.chydee-about',
      '.chydee-brand-teaser',
      '.product-problem',
      '.chydee-safety-stats',
      '.chydee-vs-alternatives',
      '.chydee-contact',
      '.chydee-catalog-banner',
    ].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (section) {
        /* Reveal all direct h2/h3/eyebrow-type children */
        var inner = section.querySelector('[class*="__inner"], [class*="__header"], [class*="__container"]');
        if (inner) revealEl(inner, 0);
      });
    });

    /* ── Lifestyle / press strips ── */
    document.querySelectorAll('.chydee-lifestyle-strip, .chydee-press-trust, .chydee-feature-strip').forEach(function (el) {
      revealEl(el, 0);
    });
  }

  /* Run after DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── Mobile touch sparkle ── */
  var TOUCH_SEL = [
    '.chydee-hero__cta',
    '.about-promise__btn',
    '.chydee-chooser__card-btn',
    '.chooser-unlock-btn',
    '.cdb__btn',
    '.cpt__cta-btn',
    '.cbt__btn',
    '.chydee-lifestyle__btn',
    '.cbs__btn',
    '.cph__atc',
    '.final-cta-button',
    '.cph__price-badge--unlock',
    '.button',
    '[type="submit"]',
  ].join(',');

  document.addEventListener('touchstart', function (e) {
    if (window.matchMedia && window.matchMedia('(max-width: 749px), (prefers-reduced-motion: reduce)').matches) return;

    var btn = e.target && e.target.closest ? e.target.closest(TOUCH_SEL) : null;
    if (!btn) return;
    btn.classList.remove('cp-touched');
    void btn.offsetWidth; /* force reflow so animation restarts */
    btn.classList.add('cp-touched');
    setTimeout(function () { btn.classList.remove('cp-touched'); }, 640);
  }, { passive: true });

})();
